

// export default PrivacyPolicy;
import React, { useState } from 'react';
import Breadcrumb from '../Pages/Breadcrumb';
import { Link } from 'react-router-dom';
import { ChevronUp, ChevronDown } from 'lucide-react';
import './PrivacyPolicy.css';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const [openSections, setOpenSections] = useState({});

  // Toggle the section open/close
  const toggleSection = (sectionId) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [sectionId]: !prevState[sectionId],
    }));
  };

  return (
    <>
      <div className='privacy-policy'>

        <Breadcrumb pages={[t('routes.privacy-policy')]} />

        <div className="container" style={{ padding: '20px' }}>
          <p className='first-sec'>
            {t('privacy.intro')}
            <Link to='/'> https://ivorytraining.com.</Link>
          </p>

          <div className="accordion-section mt-5">
            {/* Section 1 */}
            <div className='all-section-dev'>
              <button
                className={`accordion-div ${openSections.section1 ? 'active-section' : ''} w-full`}
                onClick={() => toggleSection('section1')}
              >
                <div className="two-privacy">
                  <strong>{t('privacy.sections.section1.title')}</strong>
                  <span>
                    {openSections.section1 ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                  </span>
                </div>
              </button>
              {openSections.section1 && (
                <div className='privacy-ul px-3 py-2 rounded-md'>
                  <h6>
                    - {t('privacy.sections.section1.content.personalData.title')}
                  </h6>
                  <ul>
                    <li>
                      <strong className='ml-1'>
                        {t('privacy.sections.section1.content.personalData.items.0.label')}
                      </strong>
                      <span>
                        {t('privacy.sections.section1.content.personalData.items.0.description')}
                      </span>
                    </li>
                    <li>
                      <strong className='ml-1'>
                        {t('privacy.sections.section1.content.personalData.items.1.label')}
                      </strong>
                      <span>
                        {t('privacy.sections.section1.content.personalData.items.1.description')}
                      </span>
                    </li>
                    <li>
                      <strong className='ml-1'>
                        {t('privacy.sections.section1.content.personalData.items.2.label')}
                      </strong>
                      <span>
                        {t('privacy.sections.section1.content.personalData.items.2.description')}
                      </span>
                    </li>
                  </ul>
                  <h6>
                    - {t('privacy.sections.section1.content.nonPersonalData.title')}
                  </h6>
                  <ul>
                    <li>
                      {t('privacy.sections.section1.content.nonPersonalData.items.0.description')}
                    </li>
                  </ul>
                </div>
              )}
            </div>

            {/* Section 2 */}
            <div className='all-section-dev'>
              <button
                className={`accordion-div ${openSections.section2 ? 'active-section' : ''} w-full`}
                onClick={() => toggleSection('section2')}
              >
                <div className="two-privacy">
                  <strong>{t('privacy.sections.section2.title')}</strong>
                  <span>
                    {openSections.section2 ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                  </span>
                </div>
              </button>
              {openSections.section2 && (
                <div className='privacy-ul px-3 py-2 rounded-md'>
                  <h6>{t('privacy.sections.section2.content.subtitle')}</h6>
                  <ul>
                    <li>{t('privacy.sections.section2.content.items.0')}</li>
                    <li>{t('privacy.sections.section2.content.items.1')}</li>
                    <li>{t('privacy.sections.section2.content.items.2')}</li>
                    <li>{t('privacy.sections.section2.content.items.3')}</li>
                    <li>{t('privacy.sections.section2.content.items.4')}</li>
                  </ul>
                </div>
              )}
            </div>

            {/* Section 3 */}
            <div className='all-section-dev'>
              <button
                className={`accordion-div ${openSections.section3 ? 'active-section' : ''} w-full`}
                onClick={() => toggleSection('section3')}
              >
                <div className="two-privacy">
                  <strong>{t('privacy.sections.section3.title')}</strong>
                  <span>
                    {openSections.section3 ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                  </span>
                </div>
              </button>
              {openSections.section3 && (
                <div className='privacy-ul px-3 py-2 rounded-md'>
                  <h6>
                    {t('privacy.sections.section3.content.subtitle')}
                  </h6>
                  <ul>
                    <li>{t('privacy.sections.section3.content.items.0')}</li>
                    <li>{t('privacy.sections.section3.content.items.1')}</li>
                    <li>{t('privacy.sections.section3.content.items.2')}</li>
                  </ul>
                </div>
              )}
            </div>

            {/* SEC 4 */}
            <div className='all-section-dev'>
              <button
                className={`accordion-div ${openSections.section4 ? 'active-section' : ''} w-full`}
                onClick={() => toggleSection('section4')}
              >
                <div className="two-privacy">
                  <strong>
                    {t('privacy.sections.section4.title')}
                  </strong>
                  <span>
                    {openSections.section4 ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                  </span>
                </div>
              </button>
              {openSections.section4 && (
                <div className='privacy-ul px-3 py-2 rounded-md'>
                  <h6>
                    {t('privacy.sections.section4.content.subtitle')}
                  </h6>
                  <ul>
                    <li>{t('privacy.sections.section4.content.items.0')}</li>
                    <li>{t('privacy.sections.section4.content.items.1')}</li>
                    <li>{t('privacy.sections.section4.content.items.2')}</li>
                  </ul>
                </div>
              )}
            </div>

            {/* SEC 5 */}
            <div className='all-section-dev'>
              <button
                className={`accordion-div ${openSections.section5 ? 'active-section' : ''} w-full`}
                onClick={() => toggleSection('section5')}
              >
                <div className="two-privacy">
                  <strong>
                    {t('privacy.sections.section5.title')}
                  </strong>
                  <span>
                    {openSections.section5 ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                  </span>
                </div>
              </button>
              {openSections.section5 && (
                <div className='privacy-ul px-3 py-2 rounded-md'>
                  <h6>
                    {t('privacy.sections.section5.content.subtitle')}
                  </h6>
                  <ul>
                    <li>{t('privacy.sections.section5.content.items.0')}</li>
                    <li>{t('privacy.sections.section5.content.items.1')}</li>
                  </ul>
                </div>
              )}
            </div>

            {/* SEC 6 */}
            <div className='all-section-dev'>
              <button
                className={`accordion-div ${openSections.section6 ? 'active-section' : ''} w-full`}
                onClick={() => toggleSection('section6')}
              >
                <div className="two-privacy">
                  <strong>
                    {t('privacy.sections.section6.title')}
                  </strong>
                  <span>
                    {openSections.section6 ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                  </span>
                </div>
              </button>
              {openSections.section6 && (
                <div className='privacy-ul px-3 py-2 rounded-md'>
                  <h6>
                    {t('privacy.sections.section6.content.subtitle')}
                  </h6>
                  <ul>
                    <li>{t('privacy.sections.section6.content.items.0')}</li>
                    <li>{t('privacy.sections.section6.content.items.1')}</li>
                    <li>{t('privacy.sections.section6.content.items.2')}</li>
                    <li>{t('privacy.sections.section6.content.items.3')}</li>
                  </ul>
                </div>
              )}
            </div>

            {/* SEC 7 */}
            <div className='all-section-dev'>
              <button
                className={`accordion-div ${openSections.section7 ? 'active-section' : ''} w-full`}
                onClick={() => toggleSection('section7')}
              >
                <div className="two-privacy">
                  <strong>
                    {t('privacy.sections.section7.title')}
                  </strong>
                  <span>
                    {openSections.section7 ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                  </span>
                </div>
              </button>
              {openSections.section7 && (
                <div className='privacy-ul px-3 py-2 rounded-md'>
                  <ul>
                    <li>{t('privacy.sections.section7.content.items.0')}</li>
                    <li>{t('privacy.sections.section7.content.items.1')}</li>
                  </ul>
                </div>
              )}
            </div>

            {/* SEC 8 */}
            <div className='all-section-dev'>
              <button
                className={`accordion-div ${openSections.section8 ? 'active-section' : ''} w-full`}
                onClick={() => toggleSection('section8')}
              >
                <div className="two-privacy">
                  <strong>
                    {t('privacy.sections.section8.title')}
                  </strong>
                  <span>
                    {openSections.section8 ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                  </span>
                </div>
              </button>
              {openSections.section8 && (
                <div className='privacy-ul px-3 py-2 rounded-md'>
                  <ul>
                    <li>
                      <strong className=' ml-1'>
                        {t('privacy.sections.section8.content.items.0.label')}
                      </strong>
                      <span>
                        {t('privacy.sections.section8.content.items.0.description')}
                      </span>
                    </li>
                    <li>
                      <strong className=' ml-1'>
                        {t('privacy.sections.section8.content.items.1.label')}
                      </strong>
                      <span>
                        {t('privacy.sections.section8.content.items.1.description')}
                      </span>
                    </li>
                    <li>
                      <strong className=' ml-1'>
                        {t('privacy.sections.section8.content.items.2.label')}
                      </strong>
                      <span>
                        {t('privacy.sections.section8.content.items.2.description')}
                      </span>
                    </li>
                    <li>
                      <strong className=' ml-1'>
                        {t('privacy.sections.section8.content.items.3.label')}
                      </strong>
                      <span>
                        {t('privacy.sections.section8.content.items.3.description')}
                      </span>
                    </li>
                  </ul>
                </div>
              )}
            </div>

            {/* SEC 9 */}
            <div className='all-section-dev'>
              <button
                className={`accordion-div ${openSections.section9 ? 'active-section' : ''} w-full`}
                onClick={() => toggleSection('section9')}
              >
                <div className="two-privacy">
                  <strong>
                    {t('privacy.sections.section9.title')}
                  </strong>
                  <span>
                    {openSections.section9 ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                  </span>
                </div>
              </button>
              {openSections.section9 && (
                <div className='privacy-ul px-3 py-2 rounded-md'>
                  <ul>
                    <li>{t('privacy.sections.section9.content.items.0')}</li>
                    <li>{t('privacy.sections.section9.content.items.1')}</li>
                  </ul>
                </div>
              )}
            </div>

            {/* SEC 10 */}
            <div className='all-section-dev'>
              <button
                className={`accordion-div ${openSections.section10 ? 'active-section' : ''} w-full`}
                onClick={() => toggleSection('section10')}
              >
                <div className="two-privacy">
                  <strong>
                    {t('privacy.sections.section10.title')}
                  </strong>
                  <span>
                    {openSections.section10 ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                  </span>
                </div>
              </button>
              {openSections.section10 && (
                <div className='privacy-ul px-3 py-2 rounded-md'>
                  <p>
                    {t('privacy.sections.section10.content.text')}
                    <Link to={'/contactus'} className='mx-1 text-secondary-tw underline'>
                      {t('privacy.sections.section10.content.linkText')}
                    </Link>
                    {t('privacy.sections.section10.content.continuation')}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
